import './WhyChoose.css';

const WhyChoose = () => {
  return (
    <section id="why-choose" className="section why-choose">
      <div className="container">
        <h2 className="section-title">Why Choose Tahoe Mountain Cars?</h2>
        
        <div className="why-intro">
          <p className="intro-text">
            Tahoe isn't just any destination - and a regular rental car doesn't cut it here, especially in winter.
          </p>
          <p className="intro-bold">
            We started TMC for travelers and locals who need a car ready for the mountains.
          </p>
        </div>

        <div className="audience-grid">
          <div className="audience-card">
            <h3>Visitors</h3>
            <p>
              Flying in or taking the train? Or maybe you're tagging along on a work trip and need 
              another car. We'll get you a ride that's safe and fun while you're here.
            </p>
          </div>
          <div className="audience-card">
            <h3>Locals</h3>
            <p>
              Need an extra car while yours is in the shop, or hosting family? We've got you.
            </p>
          </div>
        </div>

        <div className="features-grid">
          <div className="feature">
            <div className="feature-icon">🚙</div>
            <h4>Fun, capable vehicles</h4>
            <p>Jeeps, Ford Broncos, Subarus, Rivians, and more</p>
          </div>
          <div className="feature">
            <div className="feature-icon">📅</div>
            <h4>Flexible booking</h4>
            <p>From weekend use to monthly and seasonal leases</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🎿</div>
            <h4>Optional accessories</h4>
            <p>Ski racks, cargo boxes, bike or SUP mounts</p>
          </div>
        </div>

        <div className="seasons-container">
          <div className="season-card winter">
            <img 
              src="/assets/images/winter-ready.jpg" 
              alt="Winter ready vehicle" 
              className="season-image"
            />
            <div className="season-content">
              <h3>Winter Ready</h3>
              <ul>
                <li>AWD or 4x4 vehicles</li>
                <li>Real snow tires included</li>
                <li>Shovel, traction sand, and windshield scraper - just in case</li>
              </ul>
            </div>
          </div>

          <div className="season-card summer">
            <div className="season-content">
              <h3>Summer Fun</h3>
              <ul>
                <li>Roomy vehicles that fit right in at the lake or on the trailhead</li>
                <li>Add-ons like bike racks, coolers, and beach chairs to complete your adventure</li>
              </ul>
            </div>
            <img 
              src="/assets/images/summer-fun.jpg" 
              alt="Summer adventure vehicle" 
              className="season-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
